import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
var _ = function _(t) {
    return t;
  },
  _t;
import { fontWeight } from "../../../../constants/typography";
import mediaQueries from "../../../../util/mediaqueries";
import { spacing } from "../../../../util/spacing";
import styled from 'styled-components';
export var StyledSeeMoreLink = styled.a.withConfig({
  componentId: "sc-819kzc-0"
})(["display:flex;justify-content:flex-start;align-items:center;gap:", ";text-decoration:underline;color:inherit;transition:transform 0.2s ease-in;margin-bottom:", ";", " &:hover{transform:translateX(8px);}"], spacing(1), spacing(4), mediaQueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n    justify-content: flex-end;\n    font-weight: ", ";\n  "])), 0)), fontWeight.bold));